import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import { Navigate } from "react-router-dom";
import WarehouseOutMiddleware from "../../../../middleware/modules/warehouse/warehouse-out";
import Form from "../../../../components/modules/warehouse/warehouse-out/form";
import { Button, Modal } from "react-bootstrap";
import StoresMiddleware from "../../../../middleware/modules/master/store";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";

const mapStateToProps = ({ auth, warehouseout }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: warehouseout.isProcessing,
  isError: warehouseout.isError,
  errorMessage: warehouseout.errorMessage,
  dataUpdate: warehouseout.single,
  isSuccess: warehouseout.isSuccess,
  isReset: warehouseout.isReset,
  isNewRecord: warehouseout.isNewRecord,
  onSubmit: warehouseout.onSubmit,
  helperWarehouseOut: warehouseout.WHOutHelperFull,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // getHelperFull: () => WarehouseOutMiddleware.getHelperFull(),
      getStore: () => StoresMiddleware.getHelper(),
      closeModal: () => WarehouseOutMiddleware.reset(),
      new: (data, search) => WarehouseOutMiddleware.beforeSaveNew(data, search),
      update: (id, type, search) =>
        WarehouseOutMiddleware.beforeSaveUpdate(id, type, search),
    },
    dispatch
  );
};
class FormContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    dataUpdate: PropTypes.object,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: {},
    dataUpdate: null,
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        title: "",
        show: false,
      },
    };
    this.form = React.createRef();
    this.getData = this.getData.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.changeSelect = this.changeSelect.bind(this);
    this.close = this.close.bind(this);
  }

  getData() {
    return this.props.showOne(this.props.id);
  }

  close() {
    this.props.closeModal();
  }
  submitForm() {
    const { search, isNewRecord, dataUpdate } = this.props;
    var form = this.form.current.runSubmit();
    if (isNewRecord) {
      this.props.new(form, search);
    } else {
      this.props.update(dataUpdate.id, form, search);
    }
  }

  changeSelect(type, value = null) {
    const params = { id: value };
    switch (type) {
      case "idBranch":
        this.props.getStore(params);
        break;
      default:
        break;
    }
  }

  render() {
    const {
      helperWarehouseOut,
      branchList,
      storeList,
      isNewRecord,
      onSubmit,
      showModal,
      titleModal,
      isReset,
      dataUpdate,
      isProcessing,
      isError,
      errorMessage,
      itemList,
      unitList,
      supplierList,
      prList,
    } = this.props;
    return (
      <>
        <Modal
          show={showModal}
          fullscreen={true}
        >
          <Modal.Header>
            <Modal.Title>{titleModal}</Modal.Title>
          </Modal.Header>
          <Helmet>
                <title>{titleModal}</title>
              </Helmet>
          <Modal.Body>
            <Form
              isNewRecord={isNewRecord}
              isReset={isReset}
              data={dataUpdate}
              isProcessing={isProcessing}
              isError={isError}
              errorMessage={errorMessage}
              ref={this.form}
              storeList={storeList}
              branchList={branchList}
              helperWarehouseOut={helperWarehouseOut}
              changeSelect={this.changeSelect}
              {...this.props}

            />
          </Modal.Body>
          <Modal.Footer className={(!onSubmit)?"justify-content-between":"justify-content-center"}>
            {onSubmit ? (
              ""
            ) : (
              <Button variant="secondary" onClick={() => this.close(false)}>
                {i18n.t("Close")}
              </Button>
            )}
            <Button variant="primary" onClick={() => ((onSubmit)?false:this.submitForm(true))}>
              {onSubmit ? (
                <span className="indicator-progress show">
                  {i18n.t("Please wait...")}
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              ) : (
                <span className="indicator-label">{i18n.t("Save")}</span>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
